<template>
  <div>
    <template v-if="item.Key && item.Value">
      <w-checkbox :model="model" :value="item.Key">{{item.Value}}</w-checkbox>
    </template>
    <template v-else>
      <label v-if="item.Children && item.Children.length > 0">{{item.PelnaNazwa}}</label>
      <template v-else>
        <w-radio v-if="radioMode" :model="model" :value="item.Id">
          {{item.PelnaNazwa}}
          <small
            v-if="item.Kwota > 0"
            class="text-bold"
          >&nbsp;(maksymalna dotacja {{item.Kwota}} zł)</small>
        </w-radio>
        <w-checkbox v-else :model="model" :value="item.Id">{{item.PelnaNazwa}}</w-checkbox>
      </template>
      <template v-if="item.Children && item.Children.length">
        <ul class="list-unstyled">
          <li class="padding-left-20">
            <w-sphere
              :radio-mode="radioMode"
              :model="model"
              :item="sp"
              v-for="(sp, index) in item.Children"
              :key="index"
            ></w-sphere>
          </li>
        </ul>
      </template>
    </template>
  </div>
</template>
<script>
import WRadio from '../../components/radio.vue';
import WCheckbox from '../../components/checkbox.vue';

export default {
  name: 'w-sphere',
  props: {
    model: Object,
    item: Object,
    radioMode: Boolean
  },
  components: {
    WRadio,
    WCheckbox
  }
};
</script>
